import { toast } from "react-toastify"
import WorkflowType from "../enums/workflowType";

export const getDate = (timestampString: string) => {
  const timestamp = parseInt(timestampString)
  const date = new Date(timestamp*1000)
  const pad = (n: number) => n.toString().padStart(2, '0');

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1); // getMonth() is 0-indexed
  const year = date.getFullYear();

  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());

  return `${day}/${month}/${year} - ${hours}:${minutes}`;
} 

// export const colorPalettes: string[] =  [
//   'jet', 'hsv','hot','cool','spring','summer','autumn','winter','bone',
//   'copper','greys','YIGnBu','greens','YIOrRd','bluered','RdBu','picnic',
//   'rainbow','portland','blackbody','earth','electric',

//   'viridis', 'inferno', 'magma', 'plasma', 'warm', 'cool', 'rainbow-soft',

//   'bathymetry', 'cdom', 'chlorophyll', 'density', 'freesurface-blue', 'freesurface-red', 'oxygen', 'par', 'phase', 'salinity', 'temperature', 'turbidity', 'velocity-blue', 'velocity-green',

//   'cubehelix'
// ]

export const colorPalettes: string[] = ["magma", "viridis"]

export const getMode = (values: number[]) => {
  const sum = values.reduce((a, b) => a + b, 0)
  return sum / values.length
}

export const showSuccessToast = (message: string) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  })
}

export const showErrorToast = (message: string) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
    
  })
}

export const showLoadingToast = (message: string) => {
  return toast.loading(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  })
}

export const getWorkflowTypeString = (workflowType: number) => {
  switch (workflowType) {
    case WorkflowType.ANGULAR: return "Angular"
    case WorkflowType.PATCH: return "Patch"
    case WorkflowType.ANGULAR_SCOPE: return "Angular Scope"
    case WorkflowType.PATCH_SCOPE: return "Patch Scope"
    default: return "Unknown"
  }
}